/**
 * Shared cookie utility — single source of truth.
 * Import this everywhere instead of duplicating the same function.
 */
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};
